import React from "react";
import CurrentValues from "./CurrentValues";
import DownCaretIcon from "../../Layout/Icons/DownCaretIcon";
import QuantityDropdown from "./QuantityDropdown/";

const DropdownContainer = ({
  quantity,
  pricebreaks,
  totalPrice,
  initialPrice,
  price,
  totalSavings,
  minimumQuantity,
  quantityIncrement,
  dropdownActive,
  handleUpdateQuantity,
  handleUpdateSavings,
  handleOpenDropdown,
  handleCloseDropdown
}) => {
  return (
    <div className="quantity-dropdown">
      <CurrentValues
        quantity={quantity}
        initialPrice={initialPrice}
        totalPrice={totalPrice}
        totalSavings={totalSavings}
        handleOpenDropdown={handleOpenDropdown}
      />

      <div
        className={`quantity-dropdown__container ${dropdownActive ? "active" : "inactive"}`}
      >
        <div className="quantity-dropdown__header" onClick={handleOpenDropdown}>
          <span>Orders start at a quantity of {minimumQuantity}</span>
          <DownCaretIcon />
        </div>

        {dropdownActive && (
          <QuantityDropdown
            quantity={quantity}
            pricebreaks={pricebreaks}
            initialPrice={initialPrice}
            price={price}
            selectedQuantity={quantity.toString()}
            dropdownActive={dropdownActive}
            minimumQuantity={minimumQuantity}
            quantityIncrement={quantityIncrement}
            handleUpdateQuantity={handleUpdateQuantity}
            handleUpdateSavings={handleUpdateSavings}
            handleCloseDropdown={handleCloseDropdown}
          />
        )}
      </div>
    </div>
  );
};

export default DropdownContainer;
